import { forwardRef, memo, useImperativeHandle, useRef, useState } from "react";
import { TableCanvas } from "./TableCanvas/TableCanvas";
import "./TrucoTable.css"

const TableScreen = forwardRef((props, ref) => {
    const [currentTableDetails, setCurrentTableDetails] = useState(props.currentTableDetails || JSON.parse(localStorage.getItem("currentTableDetails")))
    const tableRef = useRef()

    useImperativeHandle(ref, () => ({
        passToChild: (fnName, data = {}, done = () => { }) => {
            tableRef.current[fnName](data, done)
        }
    }), [])

    return (
        <div className="truco-game-table">
            <TableCanvas ref={tableRef} table={currentTableDetails} sendOf={props.sendOf} />
        </div>
    );
})

export default memo(TableScreen)